import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import HighlightsGrid from './components/HighlightsGrid';
import ExclusiveGossip from './components/ExclusiveGossip';
import LatestArticles from './components/LatestArticles';
import UserReviews from './components/UserReviews';
import SubscribeSection from './components/SubscribeSection';
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from '@/components/base/SchemaOrg';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        pageUrl="http://921xwm.cn/"
        pageName="51爆料网 - 每日爆料黑料吃瓜"
        description="51爆料网每日爆料黑料吃瓜，提供51今日大瓜及每日大赛往期内容，独家八卦、往期精华免费回顾，吃瓜不停，立即查看。"
      />

      <Header />

      <main>
        <HeroSection />
        <CategoriesSection />
        <HighlightsGrid />
        <ExclusiveGossip />
        <LatestArticles />
        <UserReviews />
        <SubscribeSection />
      </main>

      <Footer />
    </>
  );
}